import { Navigate, useParams } from 'react-router-dom';

import { useGetTypeCompra } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveTypeCompras } from '../../shared/saveTypeCompras';

export interface UpdateIvaPageInterface {}

const UpdateTypeComprasPage: React.FC<UpdateIvaPageInterface> = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetTypeCompra(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_tipo_compra) return <Navigate to="/compras/tipo-compras" />;

  return <SaveTypeCompras titlePage="Editar tipo de compras" editTypeCompras={data.data} />;
};

export default UpdateTypeComprasPage;